export default "/_next/static/images/how-it-works-3x-964c5cc9cd114c947d0c4673ff9a353f.png";